import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../../graphql/types.generated';
const defaultOptions = {} as const;

export type UpdateHsCodesMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.UpdateHsCodesInput;
}>;

export type UpdateHsCodesMutationResult = { __typename?: 'Mutation' } & {
  updateHSCodes: { __typename?: 'UpdateHSCodesPayload' } & {
    errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
  };
};

export const UpdateHsCodesDocument = /*#__PURE__*/ gql`
  mutation updateHsCodes($input: UpdateHSCodesInput!) {
    updateHSCodes(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useUpdateHsCodesMutation__
 *
 * To run a mutation, you first call `useUpdateHsCodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHsCodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHsCodesMutation, { data, loading, error }] = useUpdateHsCodesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHsCodesMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateHsCodesMutationResult, UpdateHsCodesMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<UpdateHsCodesMutationResult, UpdateHsCodesMutationVariables>(UpdateHsCodesDocument, options);
}
export type UpdateHsCodesMutationHookResult = ReturnType<typeof useUpdateHsCodesMutation>;
